import {Language} from "modules/enums";
import {PersistStorage} from "modules/utils";

const SELECTED_LANG = PersistStorage.GET("language") as Language;

export const detectLanguage = (): Language => {
	if (SELECTED_LANG) {
		return SELECTED_LANG;
	}

	if (window.location.origin.includes("lcf")) {
		return Language.French;
	}

	return Language.English;
};
